<template>
    <div class="o-mobile-guide-start mobile-guide-start">
        <AButton
            v-if="isExistFinishPoint"
            :text="$t('o-services-modal_start')"
            theme="dark"
            @onClick="onStart"
        >
            <template #right>
                <svg-icon
                    original
                    name="icons/arrow-up-2"
                    class="mobile-guide-start__icon"
                />
            </template>
        </AButton>
    </div>
</template>

<script>
import AButton from '../../atoms/a-button/a-button';

export default {
    name: 'OMobileGuideStart',
    components: {
        AButton
    },
    computed: {
        isExistFinishPoint() {
            return Boolean(this.$route.query.to);
        }
    },
    methods: {
        onStart() {
            this.$emit('onStart', true);
        }
    },
}
</script>

<style lang="scss">
@import "o-mobile-guide-start";    
</style>